
      if (import.meta.env.PROD) {
        if (window.trustedTypes && !window.trustedTypes.defaultPolicy) {
          window.trustedTypes.createPolicy('default', {
            createScriptURL: (url) => {
              if (url.startsWith('https://umami.ms4all.fr/')) return url;
              return url;
            },
            createHTML: (html) => {
              return html;
            },
          });
        }

        const script = document.createElement('script');
        script.defer = true;
        script.src = 'https://umami.ms4all.fr/stats';
        script.setAttribute(
          'data-website-id',
          'd94ecb12-8482-472f-a64d-77fd5f0cf828'
        );
        document.head.appendChild(script);
      }
    